(() => {
  if (window.__taneraCardInit) return;
  window.__taneraCardInit = true;

  function initCard(card) {
    if (card.dataset.taneraReady === 'true') return;

    var dataEl = card.querySelector('[data-tanera-variants]');
    var wrap = card.querySelector('[data-tanera-form-wrap]');
    var formEl = card.querySelector('form');
    var addBtn = card.querySelector('[data-tanera-add]');
    var variantInput = card.querySelector('[data-tanera-variant-id]');

    if (!dataEl || !wrap || !formEl || !addBtn || !variantInput) return;

    var needsPick = wrap.dataset.needsPick === 'true';
    var picker = card.querySelector('[data-tanera-picker]');
    if (needsPick && !picker) return;

    var variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }
    if (!variants.length) return;

    card.dataset.taneraReady = 'true';

    var swatches = Array.prototype.slice.call(card.querySelectorAll('[data-tanera-swatch]'));
    var pills = Array.prototype.slice.call(card.querySelectorAll('[data-tanera-pill]'));
    var links = Array.prototype.slice.call(card.querySelectorAll('[data-tanera-link]'));
    var priceEl = card.querySelector('[data-tanera-price]');
    var imageEl = card.querySelector('[data-tanera-image]');
    var btnText = card.querySelector('[data-tanera-btn-text]');

    var baseUrl = wrap.dataset.productUrl || '';
    var labelAdd = wrap.dataset.labelAdd || 'Hinzufügen';
    var labelSoldOut = wrap.dataset.labelSoldOut || 'Ausverkauft';

    var selColor = swatches.length ? swatches[0].dataset.colorValue : null;
    var selPack = null;
    var busy = false;
    var preloaded = false;

    // Variantenbilder im Hintergrund vorladen. Ohne das laedt der Browser
    // das Bild erst beim ersten Swatch-Klick — genau die Verzoegerung, die
    // man dann sieht. Passiert bei Hover/Beruehrung und spaetestens, wenn
    // der Browser gerade nichts zu tun hat.
    function preloadVariantImages() {
      if (preloaded) return;
      preloaded = true;
      var seen = {};
      variants.forEach(function (v) {
        if (!v.image || seen[v.image]) return;
        seen[v.image] = true;
        var pre = new Image();
        pre.decoding = 'async';
        pre.src = v.image;
      });
    }

    card.addEventListener('pointerenter', preloadVariantImages, { once: true });
    card.addEventListener('touchstart', preloadVariantImages, { once: true, passive: true });

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(preloadVariantImages, { timeout: 4000 });
    } else {
      setTimeout(preloadVariantImages, 2500);
    }

    function currentVariant() {
      return variants.find(function (v) {
        if (selColor !== null && v.colorValue !== selColor) return false;
        if (selPack !== null && v.otherValue !== selPack) return false;
        return true;
      });
    }

    function renderPrice(v) {
      if (!priceEl) return;
      var html = '<span class="tanera-card__price-current">' + v.price + '</span>';
      if (v.compareAtPrice) {
        html += '<span class="tanera-card__price-compare">' + v.compareAtPrice + '</span>';
      }
      priceEl.innerHTML = html;
    }

    function applyVariant() {
      var v = currentVariant();
      if (!v) return;
      variantInput.value = v.id;
      card.dataset.taneraCurrentId = v.id;
      renderPrice(v);
      if (imageEl && v.image && imageEl.dataset.taneraSrc !== v.image) {
        // Erst tauschen, wenn das neue Bild fertig geladen ist. Sonst steht
        // die Karte waehrend des Ladens leer da.
        imageEl.dataset.taneraSrc = v.image;
        var next = new Image();
        next.decoding = 'async';
        next.onload = function () {
          if (imageEl.dataset.taneraSrc !== v.image) return;
          imageEl.removeAttribute('srcset');
          imageEl.removeAttribute('sizes');
          imageEl.setAttribute('src', v.image);
        };
        next.onerror = function () {
          imageEl.removeAttribute('srcset');
          imageEl.removeAttribute('sizes');
          imageEl.setAttribute('src', v.image);
        };
        next.src = v.image;
      }
      if (baseUrl) {
        links.forEach(function (link) {
          link.setAttribute('href', baseUrl + '?variant=' + v.id);
        });
      }
      addBtn.disabled = !v.available;
      if (btnText) btnText.textContent = v.available ? labelAdd : labelSoldOut;
    }

    function openPicker() {
      if (picker) picker.classList.remove('is-hidden');
      addBtn.classList.add('is-choosing');
    }

    function closePicker() {
      if (picker) picker.classList.add('is-hidden');
      addBtn.classList.remove('is-choosing');
    }

    function resetAfterAdd() {
      busy = false;
      addBtn.disabled = false;
      closePicker();
      if (needsPick) {
        selPack = null;
        pills.forEach(function (p) {
          p.classList.remove('is-selected');
        });
      }
      applyVariant();
    }

       function addToCart() {
      if (busy) return;
      var v = currentVariant();
      if (!v) return;

      var addId = v.id;
      var addQty = 1;

      if (needsPick && pills.length && selPack !== null) {
        var basePack = pills[0].dataset.qtyValue;
        var baseVariant = variants.find(function (b) {
          if (selColor !== null && b.colorValue !== selColor) return false;
          return b.otherValue === basePack;
        });
        var packNum = parseInt(selPack, 10);
        var baseNum = parseInt(basePack, 10);
        if (baseVariant && packNum > 0 && baseNum > 0 && packNum % baseNum === 0) {
          addId = baseVariant.id;
          addQty = packNum / baseNum;
        }
      }

      busy = true;
      addBtn.disabled = true;
      if (btnText) btnText.textContent = '…';

      var cartDrawer = document.querySelector('cart-drawer');
      var payload = { items: [{ id: Number(addId), quantity: addQty }] };

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        payload.sections = cartDrawer.getSectionsToRender().map(function (item) {
          return item.id;
        });
        payload.sections_url = window.location.pathname;
      }

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message || 'Cart error');

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'tanera-card',
              productVariantId: addId,
              cartData: data
            });
          }

          if (cartDrawer && data.sections) cartDrawer.renderContents(data);
          resetAfterAdd();
        })
        .catch(function (error) {
          console.error('[tanera-card] Hinzufügen fehlgeschlagen:', error);
          resetAfterAdd();
        });
    }
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        selColor = swatch.dataset.colorValue;
        selPack = null;
        swatches.forEach(function (s) {
          s.classList.toggle('is-selected', s === swatch);
        });
        pills.forEach(function (p) {
          p.classList.remove('is-selected');
        });
        closePicker();
        applyVariant();
      });
    });

    pills.forEach(function (pill) {
      pill.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        selPack = pill.dataset.qtyValue;
        pills.forEach(function (p) {
          p.classList.toggle('is-selected', p === pill);
        });
        applyVariant();
        closePicker();
        addToCart();
      });
    });

    addBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (needsPick && selPack === null) {
        openPicker();
        return;
      }
      addToCart();
    });

    formEl.addEventListener('submit', function (event) {
      event.preventDefault();
    });

    applyVariant();
  }

  function initAll() {
    document.querySelectorAll('.tanera-card').forEach(initCard);
  }

  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-tanera-picker]:not(.is-hidden)').forEach(function (open) {
      if (open.closest('.tanera-card') === event.target.closest('.tanera-card')) return;
      open.classList.add('is-hidden');
      var card = open.closest('.tanera-card');
      var btn = card && card.querySelector('[data-tanera-add]');
      if (btn) btn.classList.remove('is-choosing');
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  window.addEventListener('load', initAll);

  new MutationObserver(function () {
    initAll();
  }).observe(document.body, { childList: true, subtree: true });
})();
